import React, { useCallback, useEffect, useState } from "react";
import { Button, Col, Container, Dropdown, Navbar, Row, Table } from "react-bootstrap";
import { Helmet } from 'react-helmet';
import { BiLeftArrowAlt } from "react-icons/bi";
import { FaPlus } from "react-icons/fa";
import { HiArrowLeft } from 'react-icons/hi';
import Loader from "react-js-loader";
import Moment from 'react-moment';
import { NumericFormat } from 'react-number-format';
import { useMediaQuery } from 'react-responsive';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Header from "../../Layout/Header";
import SidebarMenu from "../../Layout/SidebarMenu";
import { BadgeStatus, getEndpointUrl, getTimestamp } from "../../Utils/Common";
import Error404 from '../Error404';
import CardOfferItem from "./CardOfferItem";
import CreateItem from "./CreateItem";
import ModalDeleteOffer from "./ModalDeleteOffer";

const DetilOffer = ({ item }) => {

    const [setItem] = useState(item);

    const [sidebarVisible, setSidebarVisible] = useState(false);

    const isMobile = useMediaQuery({ query: '(max-width: 600px)' });
    const isTabletOrLaptop = useMediaQuery({ query: '(min-width: 600px)' });

    const [error404, setError404] = useState(false);

    const [isLoading, setLoading] = useState(true);

    const [userLogin] = useState(
        JSON.parse(localStorage.getItem('knowLogin')) || []
    );

    const [accesToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    const [showDelete, setShowDelete] = useState(false);

    const [deleteData, setDeleteData] = useState({});

    const navigate = useNavigate();

    const params = useParams();

    const [offer, setOffer] = useState([]);

    const [modalCreateItem, setModalCreateItem] = useState(false);

    const fetchDataOffer = useCallback(async (offer_id) => {
        setLoading(true);
        fetch(getEndpointUrl() + `/offer/${offer_id !== undefined ? offer_id : 0}?v=${getTimestamp()}`, {
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`,
            }),
        }).then(response => response.json()).then(json => {
            if (json.status === 'ok') {
                setOffer(json.results);
            } else {
                setError404(true);
            }

            setLoading(false);
        });
    }, []);

    useEffect(() => {
        fetchDataOffer(params.offer_id);
    }, [params]);

    const onCallbackDelete = useCallback((e) => {
        navigate('/penawaran')
    }, []);

    const onCallbackOnCreateItem = useCallback((e) => {
        setLoading(true);

        fetch(getEndpointUrl() + `/offer/create_item`, {
            method: "PUT",
            body: new URLSearchParams({
                offer_id: params.offer_id,
                brandName: e.brandName,
                type: e.type,
                user_id: userLogin.id,
                builtYear: e.builtYear,
                policeNumber: e.policeNumber,
                location: e.location
            }),
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`,
            }),
        }).then(response => response.json()).then(json => {
            setLoading(false);

            if (json.status === 'ok') {
                toast.success("Yeay, Perubahan berhasil disimpan.", {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true
                });

                fetchDataOffer(params.offer_id);
            } else {
                toast.warning(json.message, {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true
                });
            }

        }).catch(error => {
            setLoading(false);
        });
    }, [params]);

    const onCallback = useCallback((e) => {
        fetchDataOffer(params.offer_id);
    }, [params]);


    return error404 ? <Error404 /> : (
        <>
            <Helmet>
                <title>Detil Penawaran</title>
            </Helmet>
            <div className="d-block d-sm-none">
                <Navbar expand="lg" className="mainNavbar border-bottom mb-3" sticky="top">
                    <a href="#" onClick={() => navigate(-1)} className="navBackMenu">
                        <HiArrowLeft />
                    </a>
                    <strong className="me-auto navTitle">Detil Penawaran</strong>
                    <Navbar.Toggle className="d-block d-sm-none me-3" onClick={(e) => setSidebarVisible(true)} />
                </Navbar>
            </div>
            <div className="d-none d-sm-inline">
                <Header />
            </div>

            <SidebarMenu show={sidebarVisible} close={(e) => setSidebarVisible(false)} />
            <ToastContainer position="top-end" className="p-3"></ToastContainer>
            <Container className="mt-4">
                <Row className="mb-4 d-none d-sm-inline">
                    <Col>
                        <Button variant="secondary" onClick={() => navigate(-1)} className="pe-3"><BiLeftArrowAlt /> Kembali</Button>
                    </Col>
                </Row>
                {isLoading ?
                    <Row>
                        <Col className="d-flex justify-content-center mt-5 pt-5 mb-3">
                            <Loader type="bubble-scale" bgColor={"#42A5F5"} size={100} />
                        </Col>
                    </Row> :
                    <Row>
                        <Col lg={8} md={9} sm={12}>
                            <div className="d-flex justify-content-end mb-3">
                                <strong className="me-auto d-none d-sm-inline">Detil Penawaran</strong>
                                <Link to={`/penawaran/cetak/${offer.id}`} className="btn btn-outline-secondary">Cetak</Link>
                                {/* <Button variant="success" className="ms-2">Kirim Penawaran</Button> */}
                                <Dropdown className="ms-2">
                                    <Dropdown.Toggle variant="primary" id="dropdown-basic">
                                        Kelola
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item href={`/penawaran/update/${offer.id}`}>Edit Penawaran</Dropdown.Item>
                                        <Dropdown.Item href="#" className="text-danger" onClick={(e) => {
                                            setShowDelete(true);
                                            setDeleteData(offer);
                                        }}>Hapus</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                            <div className="border rounded-2 p-3 text-muted fs-13">
                                <Row>
                                    <Col xs={6} sm={6} md={3} className="mb-3">
                                        <strong className="fs-13">ID PENAWARAN</strong><br /><span>{`#${offer.id}`}</span>
                                    </Col>
                                    <Col xs={6} sm={6} md={3} className="mb-3">
                                        <strong className="fs-13">TANGGAL DIBUAT</strong><br /><Moment format="DD/MM/YYYY - HH:mm A">{offer.createdAt}</Moment>
                                    </Col>
                                    <Col xs={6} sm={6} md={3} className="mb-3">
                                        <strong className="fs-13">STATUS</strong><br /><BadgeStatus status={offer.status} />
                                    </Col>
                                    <Col xs={6} sm={6} md={3} className="mb-3">
                                        <strong className="fs-13">TOTAL HARGA</strong><br />
                                        <NumericFormat
                                            value={offer.price}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                            className="fw-bold"
                                            prefix={'Rp'}
                                            renderText={(value, props) => <span {...props}>{value}</span>} />
                                    </Col>
                                </Row>
                                <strong className="fs-13 text-muted">DESKRIPSI</strong>
                                <p className="fs-13 text-muted">{offer.description}</p>
                            </div>
                            <p className="fs-13 pt-2 text-muted fst-italic">Diubah pada <Moment format="DD/MM/YYYY - HH:mm A">{offer.modified}</Moment></p>
                            <strong>Pelanggan</strong>
                            <p className="text-muted"><small>{`ID #${offer.customer_id}`}</small></p>
                            <Table striped bordered hover size="sm" className="text-muted">
                                <tr>
                                    <td className="fw-semibold" width={130}>Nama Lengkap</td>
                                    <td className="text-center fw-semibold" width={20}>:</td>
                                    <td>{offer.customerName}</td>
                                </tr>
                                <tr>
                                    <td className="fw-semibold">No. Handphone</td>
                                    <td className="text-center fw-semibold" width={20}>:</td>
                                    <td>{offer.customerPhone}</td>
                                </tr>
                                <tr>
                                    <td className="fw-semibold">Email</td>
                                    <td className="text-center fw-semibold" width={20}>:</td>
                                    <td>{offer.customerEmail}</td>
                                </tr>
                                <tr>
                                    <td className="fw-semibold">Alamat</td>
                                    <td className="text-center fw-semibold" width={20}>:</td>
                                    <td>{offer.customerAddress}</td>
                                </tr>
                                <tr>
                                    <td className="fw-semibold">Tanggal Register</td>
                                    <td className="text-center fw-semibold" width={20}>:</td>
                                    <td><Moment format="DD/MM/YYYY - HH:mm A">{offer.customerCreatedAt}</Moment></td>
                                </tr>
                            </Table>
                        </Col>
                        <Col>
                            <div className="d-flex justify-content-between">
                                <strong className="me-auto">Target Inspeksi</strong>
                                <Button variant="outline-secondary" onClick={(e) => setModalCreateItem(true)}><FaPlus /> Tambahkan Item</Button>
                                <CreateItem onCallback={onCallbackOnCreateItem} show={modalCreateItem} close={(e) => setModalCreateItem(false)} />
                            </div>
                            {offer.items?.length > 0 && offer.items.map((item, key) => (
                                <CardOfferItem item={item} key={`item-${key}`} onCallback={(e) => onCallback(e)} />
                            ))}
                        </Col>
                        <ModalDeleteOffer row={deleteData} onCallback={(e) => onCallbackDelete(e)} show={showDelete} close={() => setShowDelete(false)} />
                    </Row>
                }
            </Container>
        </>
    );
}

export default DetilOffer;
